/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Smartlab_Settings_PasswordInputs */

const vi_smartlab_settings_password = /** @type {(inputs: Smartlab_Settings_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mật khẩu`)
};

/**

* @param {Smartlab_Settings_PasswordInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const smartlab_settings_password = /** @type {((inputs?: Smartlab_Settings_PasswordInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Smartlab_Settings_PasswordInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_smartlab_settings_password(inputs)
});